import { render } from "./Home.vue?vue&type=template&id=be23beee&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=be23beee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be23beee"]])

export default __exports__